import { SVGProps } from 'react';

const Cylinder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 5c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v14c0 .796-.948 1.559-2.636 2.121S14.387 22 12 22s-4.676-.316-6.364-.879S3 19.796 3 19V5"
    />
  </svg>
);
export default Cylinder;
